const reg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const isValidEmailFormat = email => {
  return reg.test(email)
}

export function emailFormat(value, noValueMessageError, formattingErrorMessage) {
  if (!value) return noValueMessageError
  else if (!reg.test(value)) return formattingErrorMessage
  else return true
}
